// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"CustomToggle_toggleWrapper__sJsz3","label":"CustomToggle_label__aVmSo","switch":"CustomToggle_switch__sCLPW","slider":"CustomToggle_slider__-8Uay"};